import { FC } from 'react';
import { FONT_WEIGHTS } from 'shared/styles/variables';
import styled, { css } from 'styled-components';

import Spacer from 'design-system/components/Spacer';
import OptionVertical from 'inquiry/views/InquiryGovernmentIdSelectView/OptionVertical';
import OptionVerticalRedesign from 'inquiry/views/InquiryGovernmentIdSelectView/OptionVerticalRedesign';
import { GovernmentIdClass } from 'lib/constants/governmentIds';
import { colorCss, fontWeightCss } from 'lib/inquiryStyles';
import {
  SerializedStepGovernmentIdStyles,
  StepGovernmentIdConfig,
} from 'lib/interfaces/StepsConfig';
import { TextComponentStyles } from 'lib/interfaces/ui-components';

const ChooseOptionNotice = styled('div')<{ styles: TextComponentStyles }>`
  ${({ styles }) =>
    styles != null
      ? css`
          color: ${colorCss(styles['text-color'].base.base)};
          font-weight: ${fontWeightCss(styles['font-weight'].base.base)};
          text-align: ${styles['justify'].base.base};
        `
      : css`
          color: ${({ theme }) => theme.colorFontTitle};
          font-weight: ${FONT_WEIGHTS.medium};
        `};
`;

interface GovernmentIdOptionsProps {
  assets: StepGovernmentIdConfig['assets']['select-page'];
  idClasses: StepGovernmentIdConfig['idclasses'];
  idClassListStyle: 'outline' | 'outline_light' | 'button';
  localizations: StepGovernmentIdConfig['localizations']['select-page'];
  selectedCountryCode: StepGovernmentIdConfig['selected-country-code'];
  handleSelectType: (type: GovernmentIdClass) => void;
  enableRedesign: boolean;
  styles?: TextComponentStyles;
  optionStyles?: SerializedStepGovernmentIdStyles['selectOption'];
}

export default GovernmentIdOptions as FC<GovernmentIdOptionsProps>;

function GovernmentIdOptions({
  assets,
  idClasses,
  idClassListStyle,
  localizations,
  selectedCountryCode,
  handleSelectType,
  enableRedesign,
  styles,
  optionStyles,
}: GovernmentIdOptionsProps) {
  return (
    <>
      {idClassListStyle !== 'button' && !!localizations['option-notice'] && (
        <>
          <ChooseOptionNotice styles={styles}>{localizations['option-notice']}</ChooseOptionNotice>
          <Spacer height={1} />
        </>
      )}

      {idClasses.map((idClass) =>
        enableRedesign ? (
          <OptionVerticalRedesign
            key={idClass.class}
            assets={assets}
            buttonType={idClassListStyle}
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            countryCode={selectedCountryCode}
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            handleSelectType={handleSelectType}
            governmentIdClass={idClass.class}
            icon={idClass.icon}
            localizations={localizations}
            styles={optionStyles}
          />
        ) : (
          <OptionVertical
            key={idClass.class}
            buttonType={idClassListStyle}
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            countryCode={selectedCountryCode}
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            handleSelectType={handleSelectType}
            governmentIdClass={idClass.class}
            localizations={localizations}
          />
        ),
      )}

      <Spacer height={4} />
    </>
  );
}
